import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ProductForm from '../Form';
import { createProduct } from '@resources/Product/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { module, createProduct, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createProduct(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.product.create',
						defaultMessage:
							'A new Product has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.product',
					defaultMessage: 'Create Product',
				})}
			</Title>
			<ProductForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({ products, modules, event, organization }) => {
	return {
		products,
		modules,
		event,
		organization,
	};
};

export default connect(mapStateToProps, {
	createProduct,
	fetchModulesBySubmoduleCode,
})(Create);
